var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-com"},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":[6, 20, 50, 100, 500, 1000, 2000],"page-size":_vm.size,"layout":"prev, pager, next,sizes,total","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }